
import { defineComponent, computed, PropType, ref } from "vue";
export default defineComponent({
   props: {
      /**
       * @param {String} className 传入样式名
       */
      cardClass: {
         type: String as PropType<string>,
         default: "",
      },

      /**
       * @param {String} className 传入样式名
       */
      headerClass: {
         type: String as PropType<string>,
         default: "",
      },

      /**
       * @param {String} title 标题名称
       */
      title: {
         type: String,
         default: null,
      },

      /**
       * @param {Boolean} header 显示标题
       */
      header: {
         type: Boolean,
         default: false,
      },

      /**
       * @param {String, Number} round 圆角尺寸
       */
      round: {
         type: [String, Number],
         default: 8,
      },

      /**
       * @param {String, Number} 内边距右边的距离
       */
      pr: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {String, Number} 内边距左边的距离
       */

      pl: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {String, Number} 内边距上边的距离
       */

      pt: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {Number} 内边距下边的距离
       */
      pb: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {Boolean} 头部没有border
       */
      headerBorderNo: {
         type: [Boolean],
         default: false,
      },

      /**
       * @param {Boolean} 是否展示放大缩小按钮
       */
      isShowFull: {
         type: [Boolean],
         default: false,
      },
   },
   setup(props, ctx:any) {
      //--------------------合并class--------------------

      /**
       * @method setCardClassName 合并卡片calss
       * @method setHeaderClassName 合并卡片头部calss
       */
      const isFull = ref(null);
      const fullClass = ref('');

      const setCardClassName = computed((): string[] => {
         return [fullClass.value,"sz-card", ...props.cardClass.split(" ")];
      });

      const setHeaderClassName = computed(() => {
         return ["header__left--title", ...props.headerClass.split(" ")];
      });


      const changeFullFn = (type:any)=>{
         isFull.value = type;
         fullClass.value = type?'full-screen-card':'';
      }

      return {
         setCardClassName,
         setHeaderClassName,
         changeFullFn,
         isFull,
      };
   },
});
